import { useRoute } from "wouter";
import { TechRadar } from "../components/TechRadar/index";
import { CategoryInfoScreen } from "./CategoryInfoScreen";
import { Helmet } from "react-helmet-async";

export function TechRadarScreen() {
	const [projectInfoMatch] = useRoute("/tech-radar/project-info");
	const [categoryInfoMatch, params] = useRoute("/tech-radar/category/:slug");

	return (
		<div>
			<Helmet>
				<title>Tech Radar | L'Atelier Virtual Economy Technology Radar</title>
			</Helmet>
			<TechRadar
				modalOpen={projectInfoMatch || categoryInfoMatch}
				activeCategory={params?.slug}
			/>
			<CategoryInfoScreen />
		</div>
	);
}
